import React from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.mergewith';

import FetchContext from '../fetch-context';

class Data extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: true,
      showLoader: true,
      data: null,
      errors: null,
      offset: 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.state.fetching) {
      return;
    }

    if (this.props.refreshKey !== prevProps.refreshKey) {
      this.refresh();
    }
  }

  componentDidMount() {
    this.run();
  }

  async run() {
    const { fetchContext, query, variables } = this.props;

    this.setState({
      data: null,
      errors: null,
      fetching: true,
      showLoader: true,
    });

    const response = await fetchContext.query(query, variables);

    this.setState({ ...response, fetching: false, showLoader: false });
  }

  async refresh() {
    const { fetchContext, query, variables } = this.props;

    this.setState({ fetching: true });

    const { data, errors } = await fetchContext.query(query, variables);

    this.setState({ data, errors, fetching: false });
  }

  async mutation(query, variables, options = {}) {
    const { showLoader = false, refresh = true } = options;

    const { data, errors } = await this.props.fetchContext.query(
      query,
      variables
    );

    this.setState({ fetching: true, showLoader });

    if (refresh) {
      await this.refresh();
    }

    return { data, errors };
  }

  async fetchMore() {
    if (!this.props.variables.limit) {
      throw new Error('Need limit variables in <Data> to fetch more');
    }

    this.setState({
      fetching: true,
    });

    const { fetchContext, query, variables } = this.props;
    const newOffset = this.state.offset + variables.limit;

    const { data, errors } = await fetchContext.query(query, {
      ...variables,
      offset: newOffset,
    });

    this.setState(prevState => ({
      offset: newOffset,
      fetching: false,
      data: merge({}, prevState.data, data, (objValue, srcValue) => {
        if (Array.isArray(objValue)) {
          return objValue.concat(srcValue);
        }

        return undefined;
      }),
      errors,
    }));
  }

  render() {
    if (this.state.fetching && this.state.showLoader) {
      return this.props.renderLoader();
    }
    if (this.state.errors) {
      return this.props.renderError();
    }

    return this.props.render({
      ...this.state,
      refresh: () => this.refresh(),
      mutation: (q, v, o) => this.mutation(q, v, o),
      fetchMore: () => this.fetchMore(),
    });
  }
}

const { func, string, shape, object } = PropTypes;

Data.propTypes = {
  fetchContext: shape({
    query: func,
  }).isRequired,
  query: string.isRequired,
  variables: object, // eslint-diable-line react/forbid-prop-types
  renderLoader: func,
  renderError: func,
  render: func.isRequired,
  refreshKey: string,
};

Data.defaultProps = {
  variables: {},
  renderLoader: () => null,
  renderError: () => null,
  refreshKey: undefined,
};

export default props => (
  <FetchContext.Consumer>
    {fetchContext => <Data {...props} fetchContext={fetchContext} />}
  </FetchContext.Consumer>
);
